export default function mainScript(events) {
  const cores = document.querySelectorAll('.coreImg')
  const prizes = document.querySelectorAll('.prize')
  const prizeTitles = document.querySelectorAll('.prizeTitle')
  const prizeSubTitles = document.querySelectorAll('.prizeSubTitle')
  const logoWrapper =  document.querySelector('.logoWrapper')
  const title = document.querySelector('.title')
  const congratulationTitle = 'Вітаємо!'
  const congratulationSubTitle = 'Ти виграв Бонус'
  const description = document.querySelector('.description')
  const configPrizes = {
    main: {
      title: 'до <span>125 000 ₴</span>',
      subTitle: '+ <span>500 FS</span>'
    },
    iphone: {
      title: 'iPhone',
      subTitle: '14'
    },
    cashback: {
      title: 'Повернення',
      subTitle: 'депозиту'
    }
  }
  var animateActivate = false
  cores.forEach(core => {
    core.addEventListener('click', (e) => {
        if(animateActivate) return
        events.loadScriptFormEvent.emit('loadScriptForm')
        animateActivate = true
        e.target.classList.add('fadeOut')
        removeAnimate()
        setPrizes(parseInt(e.target.dataset.coreid))
        prizes[parseInt(e.target.dataset.coreid)].src = '/components/main/img/prize.webp'
        prizes[parseInt(e.target.dataset.coreid)].classList.add('fadeIn')
        prizes[parseInt(e.target.dataset.coreid)].classList.add('winner')
        prizeTitles[parseInt(e.target.dataset.coreid)].innerHTML = configPrizes.main.title
        prizeTitles[parseInt(e.target.dataset.coreid)].classList.add('fadeIn')
        prizeTitles[parseInt(e.target.dataset.coreid)].classList.add('winnerText')
        prizeSubTitles[parseInt(e.target.dataset.coreid)].innerHTML = configPrizes.main.subTitle
        prizeSubTitles[parseInt(e.target.dataset.coreid)].classList.add('fadeIn')
        prizeSubTitles[parseInt(e.target.dataset.coreid)].classList.add('winnerText')
        changeContent()
        setTimeout(changeState, 2000)
        setTimeout(()=>{
          events.showFormEvent.emit('showForm')
        }, 6000)
    })
  })
  function removeAnimate() {
    cores.forEach(item => item.classList.remove('animate'))
  }
  function setPrizes(prizeIndex) {
     if(prizeIndex === 0) {
        prizes[1].src = '/components/main/img/iphone.webp'
        prizes[1].classList.add('prizeIphone')
        prizeTitles[1].innerHTML = configPrizes.iphone.title
        prizeSubTitles[1].innerHTML = configPrizes.iphone.subTitle
        prizes[2].src = '/components/main/img/prize.webp'
        prizeTitles[2].innerHTML = configPrizes.cashback.title
        prizeSubTitles[2].innerHTML = configPrizes.cashback.subTitle
     } 
     else if(prizeIndex === 1) {
        prizes[2].src = '/components/main/img/iphone.webp'
        prizes[2].classList.add('prizeIphone')
        prizeTitles[2].innerHTML = configPrizes.iphone.title
        prizeSubTitles[2].innerHTML = configPrizes.iphone.subTitle
        prizes[0].src = '/components/main/img/prize.webp'
        prizeTitles[0].innerHTML = configPrizes.cashback.title
        prizeSubTitles[0].innerHTML = configPrizes.cashback.subTitle
     } 
     else if(prizeIndex === 2) {
        prizes[0].src = '/components/main/img/iphone.webp'
        prizes[0].classList.add('prizeIphone')
        prizeTitles[0].innerHTML = configPrizes.iphone.title
        prizeSubTitles[0].innerHTML = configPrizes.iphone.subTitle
        prizes[1].src = '/components/main/img/prize.webp'
        prizeTitles[1].innerHTML = configPrizes.cashback.title
        prizeSubTitles[1].innerHTML = configPrizes.cashback.subTitle
     }
  }
  function changeState() {
    cores.forEach((item, index) => {
      cores[index].classList.add('fadeOut')
      prizes[index].classList.add('fadeIn')
      prizeTitles[index].classList.add('fadeIn')
      prizeSubTitles[index].classList.add('fadeIn')
    })
  }
  function changeContent() {
    logoWrapper.innerHTML = congratulationTitle
    title.innerHTML = congratulationSubTitle
    title.classList.add('congratulationTitle')
    description.innerHTML = ''
  }
}